namespace appn.views.dataSources.create {

    export function init(): void {
        addEvents();
    }

    function addEvents() {
        // Hook save link
        $('#saveLink').click(function(): void {
            $('form#appnForm').submit();
        });
    }
}
